namespace Pet {
  export const isIncomplete = (pet: Pet.ILevel1) => {
    return pet.incomplete_fields?.length
  }

  export type UpdateDraft = Pick<ILevel1, 'name' | 'gender' | 'is_neutered' | 'photo_url'> & {
    breed: string | null
    species: string | null
    age: string
  }

  export const isUpdateDraft = (pet: Pet.ILevel1 | Pet.UpdateDraft) => {
    return 'age' in pet && 'breed' in pet && 'species' in pet
  }

  export interface ILevel1 {
    id: number | null
    name: string
    kind: Kind
    photo_url: string
    born_year: number | null
    born_at: string | null
    gender: Pet.Gender | null
    is_neutered: boolean | null
    bio: string
    fear: string
    issue: string
    favorite_thing: string
    favorite_human_food: string
    favorite_human: string
    incomplete_fields: string[] | null
  }

  export class Level1 implements ILevel1 {
    id: number | null = null
    name = ''
    kind: Kind = { depth1: '', depth2: '', main: '' }
    photo_url = ''
    born_year: number | null = null
    born_at: string | null = null
    gender: Pet.Gender | null = null
    is_neutered: boolean | null = null
    bio = ''
    fear = ''
    issue = ''
    favorite_thing = ''
    favorite_human_food = ''
    favorite_human = ''
    incomplete_fields: string[] | null = null

    constructor(json?: ILevel1 | null) {
      if (json) {
        this.id = json.id ? json.id : null
        this.name = json.name
        this.kind = json.kind
        this.photo_url = json.photo_url
        this.born_year = json.born_year
        this.born_at = json.born_at
        this.gender = json.gender
        this.is_neutered = json.is_neutered
        this.bio = json.bio
        this.fear = json.fear
        this.issue = json.issue
        this.favorite_thing = json.favorite_thing
        this.favorite_human_food = json.favorite_human_food
        this.favorite_human = json.favorite_human
        this.incomplete_fields = json.incomplete_fields || []
      }
      return { ...this }
    }
  }

  export const Gender = {
    Male: 0,
    Female: 1,
    Unknown: 2,
  } as const

  export type Gender = (typeof Gender)[keyof typeof Gender]

  export const Kinds = {
    Dog: 'Dog',
    Cat: 'Cat',
    Bird: 'Bird',
    Others: 'Others',
  } as const

  export type Kinds = (typeof Kinds)[keyof typeof Kinds]

  export interface Kind {
    depth1: string | null
    depth2: string | null
    id?: number
    main?: string
  }
}

export default Pet
